import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { AuthService } from '../../../../service/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-uniRegistrationForm',
  templateUrl: './uniRegistrationForm.component.html',
  styleUrls: ['./uniRegistrationForm.component.css']
})
export class UniRegistrationFormComponent implements OnInit {
  public registrationForm: FormGroup;
  loading: boolean;
  data: Object;

  constructor(
    private builder: FormBuilder,
    private authService: AuthService,
    private _snackBar: MatSnackBar,
    ) { }

  ngOnInit() {
        // Limpiar los datos del usuario al entrar a la página de Login. Por el
    // momento se hace acá, pero después debiese pasar en los guards o en algún
    // otro lado
    // Setear el formulario para iniciar sesión
    this.loading = false
    this.registrationForm = this.builder.group({

      email : [ null,  [ Validators.required ] ],
      role: [ null, [ Validators.required ] ]
    });
  }

  confirm(){
    this.data = {
      email: this.registrationForm.controls.email.value,
      role: this.registrationForm.controls.role.value,
    };
    this.loading = true
    this.authService.createUniUser(this.data)
    .then(resp =>{
      this.loading = false
      console.log(resp)
      if (resp.status == 200){
        console.log(resp.body)
        this._snackBar.open("Email Sent", "",{
          duration:  5000,
        });
      }
    })
    .catch(e => {
      this.loading = false
      console.log(e)
      if (e.status ==409){
        console.log("Not Valid")
        this._snackBar.open("Email Sent", "",{
          duration:  5000,
        });
      }
    })

  }

  resendLink(){
    const data: any = {
      email: this.registrationForm.controls.email.value,
      password: this.registrationForm.controls.password.value
    };
    this.loading = true
    this.authService.createUniUser(this.data)
    .then(resp =>{
      this.loading = false
      console.log(resp)
      if (resp.status == 200){
        console.log(resp.body)
        this._snackBar.open("Email Sent", "",{
          duration:  5000,
        });
      }
    })
    .catch(e => {
      this.loading = false
      console.log(e)
      if (e.status ==409){
        console.log("Not Valid")
        this._snackBar.open("Email Sent", "",{
          duration:  5000,
        });
      }
    })

  }

}

